//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import xmldom from 'xmldom';

var MarkupParser = function() {
  var self = this;

  this.parseXml = function(xmlString) {
    return self.parseMarkup(xmlString, 'text/xml');
  };

  var tryParse = function(markupString, contentType) {
    var parser = new window.DOMParser();

    var dom = null;
    try {
      dom = parser.parseFromString(markupString, contentType);
    } catch (ex) {
      console.warn(ex);
      return null;
    }
    //check for an empty result (native browser xml parsing problems)
    if (
      !dom ||
      !dom.childNodes ||
      !dom.childNodes.length ||
      dom.getElementsByTagNameNS('*', 'parsererror').length
    ) {
      return null;
    }
    return dom;
  };

  this.parseMarkup = function(markupString, contentType) {
    // XML BOM at the start of the markup string could become leading whitespace.
    // Which causes a parser error. Trimming resolves it.
    if (markupString) {
      markupString = markupString.trim();
    }

    var dom = tryParse(markupString, contentType);
    if (!dom) {
      console.log('Need to use fallback DOMParser implementation');
      var parser = new xmldom.DOMParser();
      dom = parser.parseFromString(markupString, contentType);
    }
    return dom;
  };

  this.isValidXml = function(markupString, contentType) {
    return !!tryParse(markupString, contentType);
  };
};

export default MarkupParser;
